// @flow

import { useTranslator } from '@gandi/translate';

import type { DomainProduct } from '../types';

import { PriceAndCartButton } from './PriceAndCartButton';
import { ResultRow } from './ResultRow';

type Props = {
  result: DomainProduct,
};

export const TransferableResult = ({ result }: Props): React.MixedElement => {
  const { __ } = useTranslator();

  return (
    <ResultRow
      iconName="available"
      statusText={__('Transfer')}
      fqdn={result.fqdn}
      pricingBlock={
        <PriceAndCartButton
          result={result}
          addToCartButtonLabel={__('Add to cart')}
          process="transfer"
        />
      }
    />
  );
};
